/** The status of an animal transporter certificate; mirrors backend `OKIS.Domain.Shared.Vehicles.AnimalTransporterStatus`. */
export enum AnimalTransporterStatus {
	InEvaluation = 1,
	Active = 2,
	Paused = 3,
	Canceled = 4,
}

/**
 * A lifecycle action of the status change modal: the target status, its verb label („Aktyvuoti" / „Sustabdyti" /
 * „Atšaukti") and whether the action requires a date.
 */
export interface AnimalTransporterStatusActionOption {
	id: AnimalTransporterStatus;
	label: string;
	requiresDate: boolean;
}

/** Every lifecycle action; the modal offers those `TRANSITIONS` allows from the current status. */
export const ANIMAL_TRANSPORTER_STATUS_ACTION_OPTIONS: AnimalTransporterStatusActionOption[] = [
	{ id: AnimalTransporterStatus.Active, label: 'Aktyvuoti', requiresDate: false },
	{ id: AnimalTransporterStatus.Paused, label: 'Sustabdyti', requiresDate: true },
	{ id: AnimalTransporterStatus.Canceled, label: 'Atšaukti', requiresDate: true },
];

/** The status transitions: the statuses each status can move to; `Canceled` is terminal. */
export const ANIMAL_TRANSPORTER_STATUS_TRANSITIONS: Record<AnimalTransporterStatus, AnimalTransporterStatus[]> = {
	[AnimalTransporterStatus.InEvaluation]: [AnimalTransporterStatus.Active, AnimalTransporterStatus.Canceled],
	[AnimalTransporterStatus.Active]: [AnimalTransporterStatus.Paused, AnimalTransporterStatus.Canceled],
	[AnimalTransporterStatus.Paused]: [AnimalTransporterStatus.Active, AnimalTransporterStatus.Canceled],
	[AnimalTransporterStatus.Canceled]: [],
};
